import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Register from '../components/modals/Auth/register'
import { setModal } from '../redux/modals-reducer'
import Auth from './modals/Auth'
import Cart from './modals/Cart'

const Wrapper = styled.div`
    background: rgba(27, 27, 27, 0.25);
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    right: 0;
`

const Modal = ({ modalId, setModal }) => {
    useEffect(() => {
        if (modalId) {
            return document.body.classList.add('showModal')
        }

        return document.body.classList.remove('showModal')
    }, [modalId])

    if (!modalId) {
        return null
    }

    const MODALS = {
        'CART': <Cart />,
        'AUTH': <Auth />,
        'REGISTER': <Register />,
    }

	return (
        <Wrapper>
            {MODALS[modalId]}
        </Wrapper>
    )
}

export default connect((state) => {
    return {
        modalId: state.modals.modalId
    }
}, { setModal })(Modal)